import styles from './TextBlock.scss';

import cx from 'classnames';
import React from 'react';

import { ITextStackProps, TextStack } from 'src/components/TextStack/TextStack';

export const TextBlock: React.FC<ITextStackProps<HTMLDivElement>> = ({
  className, titleClassName, blurbClassName, linkClassName, ...props
}) => (
  <TextStack
    className={cx(styles.textBlock, className)}
    titleClassName={cx(styles.title, titleClassName)}
    blurbClassName={cx(styles.blurb, blurbClassName)}
    linkClassName={cx(styles.link, linkClassName)}
    {...props}
  />
);
